export default __webpack_public_path__ + "static/media/Sharjah-Mun-Logo.935f40b0.svg";